import React from 'react'
import { RouterProvider } from 'react-router'

import { AuthProvider } from './auth/AuthContext'
import ErrorBoundary from './components/ErrorBoundary'
import router from './router'

const App: React.FC = () => (
  <ErrorBoundary>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </ErrorBoundary>
)
App.displayName = 'App'
export default App
